export { default as DeploymentTabs } from './Tabs';
